import jschardet from 'jschardet';
import Papa from 'papaparse';

export const Csv = async function (file) {
  let fileInfo = { raw: [], data: [], type: "" }
  let code = await judgmentCode(file);
  let text = await readFile(file, code.encoding);
  parseCsv(text, fileInfo);
  typePrediction(fileInfo);
  return fileInfo;
}

function readFile(file, code = null) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = function (evt) {
      resolve(evt.target.result);
    };

    if(code === null) {
      reader.readAsBinaryString(file);
    } else {
      reader.readAsText(file, code);
    }
  });
}

async function judgmentCode(file) {
  let buffer = await readFile(file);
  return jschardet.detect(buffer);
}

function parseCsv(data, fileInfo) {
  fileInfo.raw = Papa.parse(data).data;

  let maxColumn = 0;
  fileInfo.raw.forEach(v => {
    maxColumn = maxColumn < v.length ? v.length : maxColumn;
    for(let i = 0; i<v.length; i++) {
      v[i] = v[i].trim();
    }
  })

  fileInfo.raw.forEach(v => {
    if(v.length == maxColumn) fileInfo.data.push(v);
  })

  return;
}

function typePrediction(fileInfo) {
  switch (fileInfo.raw[0][0]) {
    case "支付宝交易记录明细查询":
      fileInfo.type = "支付宝";
      break;
    case "微信支付账单明细":
      fileInfo.type = "微信";
      break;
    default:
      break;
  }

  if(fileInfo.type === "") {
    switch (fileInfo.raw[0].join(",")) {
      case 'ID,时间,类型,父分类,子分类,金额,扣款账户,收款账户,备注':
        fileInfo.type = "汤圆记账";
        break;
      case 'ID,时间,分类,类型,金额,账户1,账户2,备注,账单图片':
        fileInfo.type = "钱迹";
        break;
      case 'ID,时间,分类,类型,金额,账户1,账户2,备注,账单图片,记账者':
        fileInfo.type = "钱迹";
        break;
      // case '序号,类型,货币,金额,汇率（相对本位币）,项目,分类,父类,账户,付款,收款,商家,地址,日期,备注':
      //   fileInfo.type = "薄荷记账";
      //   break;
    }
  }
}
String.prototype.trim = function (char, type) {
  if (char) {
    if (type == 'left') {
      return this.replace(new RegExp('^\\' + char + '+', 'g'), '');
    } else if (type == 'right') {
      return this.replace(new RegExp('\\' + char + '+$', 'g'), '');
    }
    return this.replace(new RegExp('^\\' + char + '+|\\' + char + '+$', 'g'), '');
  }
  return this.replace(/^\s+|\s+$/g, '');
};